module.exports = __webpack_public_path__ + "img/sand-decal-20.e8bb9c92.png";